import React from 'react';

export const EducationListPage = React.lazy(() => import('@features/education/pages/education-list/education-list'));

export const EducationDetailPage = React.lazy(() => import('@features/education/pages/education-detail/education-detail'));
